import { Toast } from "./toast-index.js";
import { configureToasts } from "./toast-index.js";
import { rbbPost } from "./api.js";
import { clearModal, closeModal } from "./modal.js";

configureToasts({
  topOrigin: -100
});

const RBB = window.RBB;

export const throwToast = ( message, toastType ) => {
  let element = document.createElement("div");
  element.textContent = message;
  let newToast = new Toast(element, toastType, Toast.TIME_NORMAL);
  element.addEventListener("click", () => newToast.delete());
};

export const getLoader = () => {
  return "<div class=\"loadingio-spinner-ripple-99zh1h91d7b\"><div class=\"ldio-mg9i89wywrl\"><div></div><div></div></div></div>";
};

export const clearPortalFeedback = () => {
  const feedback = document.getElementById("portal-feedback");
  if (!!feedback) {
    feedback.innerText = "";
    feedback.className = "";
  }
};

const nth = ( d ) => {
  if (d > 3 && d < 21) {
    return "th";
  }
  switch (d % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export const initiateGiftSetup = () => {
  const date = new Date().getDate();
  const kit_a_description = RBB.kit_a_description();
  const kit_a_available = RBB.variant_a_available();
  const kit_b_description = RBB.kit_b_description();
  const kit_b_available = RBB.variant_b_available();
  let modalBody;
  if (date < 27) {
    modalBody = "Once you select your book your subscription will start now.";
  }
  else {
    modalBody = "Once you select your book, your subscription will start on the 1st of next month.";
  }
  const kitADiv = document.createElement("div");
  const kitBDiv = document.createElement("div");
  kitADiv.innerHTML = "<h3>book a</h3>";
  kitADiv.innerHTML += kit_a_description;
  kitBDiv.innerHTML = "<h3>book b</h3>";
  kitBDiv.innerHTML += kit_b_description;
  clearModal();
  const bodyElement = document.getElementById("modal-body");
  const controlsElement = document.getElementById("modal-controls");
  const title = document.createElement("h3");
  title.innerText = "step 4 - confirm start";
  const body = document.createElement("p");
  body.innerText = modalBody;
  const selectKitA = document.createElement("button");
  selectKitA.classList.add("btn", "btn--primary", "btn--small", "btn--select-kit");
  selectKitA.id = "btn-select-a";
  if (kit_a_available) {
    selectKitA.dataset.product = RBB.product_a();
    selectKitA.dataset.kit = RBB.variant_a();
    selectKitA.dataset.hash = RBB.kit_a_hash();
    selectKitA.dataset.title = "Book A";
    selectKitA.innerText = "Select Book A";
  }
  else {
    selectKitA.innerText = "Book A Sold Out";
    selectKitA.disabled = true;
  }
  const selectKitB = document.createElement("button");
  selectKitB.classList.add("btn", "btn--primary", "btn--small", "btn--select-kit");
  selectKitB.id = "btn-select-b";
  if (kit_b_available) {
    selectKitB.dataset.product = RBB.product_b();
    selectKitB.dataset.kit = RBB.variant_b();
    selectKitB.dataset.hash = RBB.kit_b_hash();
    selectKitB.dataset.title = "Book B";
    selectKitB.innerText = "Select Book B";
  }
  else {
    selectKitB.innerText = "Book B Sold Out";
    selectKitB.disabled = true;
  }
  const cancelButton = document.createElement("button");
  cancelButton.classList.add("btn", "btn--secondary", "btn--small");
  cancelButton.innerText = "Cancel";
  bodyElement.appendChild(title);
  bodyElement.appendChild(body);
  bodyElement.appendChild(kitADiv);
  bodyElement.appendChild(kitBDiv);
  controlsElement.appendChild(selectKitA);
  controlsElement.appendChild(selectKitB);
  controlsElement.appendChild(cancelButton);
  selectKitA.addEventListener("click", completeGiftSetup);
  selectKitB.addEventListener("click", completeGiftSetup);
  cancelButton.addEventListener("click", closeModal);
};

const completeGiftSetup = async ( evt ) => {
  const kit = evt.target.dataset.kit;
  const hash = evt.target.dataset.hash;
  const title = evt.target.dataset.title;
  const product = evt.target.dataset.product;
  closeModal();
  const completeSetupButton = evt.target;
  const addAddressButton = document.getElementById("add-new-address");
  const feedback = document.getElementById("setup-feedback");
  feedback.className = "info";
  completeSetupButton.classList.add("btn--loading");
  document.querySelectorAll(".btn--select-kit").forEach(el => el.removeEventListener("click", completeGiftSetup));
  addAddressButton.disabled = true;
  const customerId = RBB.shopify_customer_id();
  if (parseInt(customerId) > 0) {
    const token = RBB.token();
    let postData = {
      shopify_customer_id: customerId,
      portalToken: token,
      productId: product,
      variantId: kit,
      title: title,
      hash: hash
    };
    feedback.innerHTML += "<p id=\"subscription-create\">Activating subscription - please wait...</p>";
    let url = "/apps/rbbr/recharge/activateGiftSubscription";
    await rbbPost(url, postData).then(response => response.json()).then(subscription => {
      feedback.innerHTML += `<p id="subscription-response">${subscription.body}</p>`;
      if (subscription.statuscode === 200) {
        const date = new Date().getDate();
        let whenBookPosted = "";
        if (date < 27) {
          whenBookPosted = "your book will be posted in the next business day, so watch out for its arrival!";
        }
        else {
          whenBookPosted = "your book will be posted in the first couple of days of next month.";
        }
        const initialSetupDiv = document.getElementById("initial-setup");
        document.getElementById("subscription-create").innerHTML += "&#10004;";
        feedback.innerHTML += `<p id="book-response">Book added - all done!</p>`;
        feedback.innerHTML += `<p>Your subscription is now all setup with your first book selection; ${whenBookPosted}</p>`;
        feedback.innerHTML += `<p>You now have access to the members area of the site, so feel free to have a browse around, join in any discussions, and see what else is there.</p>`;
        feedback.className = "success";
        initialSetupDiv.innerText = "";
        document.getElementById("redeeming-step-3").remove();
        initialSetupDiv.appendChild(feedback);
      }
      else {
        cancelActivation();
        completeSetupButton.classList.remove("btn--loading");
      }
    });

  }
};

const cancelActivation = () => {
  const completeSetupButton = document.getElementById("complete-setup");
  const addAddressButton = document.getElementById("add-new-address");
  const feedback = document.getElementById("setup-feedback");
  feedback.className = "error";
  completeSetupButton.classList.remove("btn--loading");
  completeSetupButton.addEventListener("click", completeGiftSetup);
  addAddressButton.disabled = false;
};

export const clearWrappers = () => {
  document.querySelectorAll("#portal-wrappers .subscribers").forEach(( el ) => el.classList.add("hide"));
  document.querySelectorAll("#portal-wrappers .subscribers.empty .new-grid .top-wrapper > div")
    .forEach(( el ) => el.innerText = "");
};

export const setActivePortalOption = ( id ) => {
  document.querySelectorAll(".portal-options__item").forEach(( el ) => {
    el.classList.add("inactive");
    el.classList.remove("active");
  });
  document.querySelector(`[data-id="${id}"]`).classList.remove("inactive");
  document.querySelector(`[data-id="${id}"]`).classList.add("active");
};